import { Row, Col, Table, Button } from "antd";
import Back from "../../../assets/images/backIcon.svg";
import RetailModals from "../../PointOfSale/Retail/RetailModals";

const CashManagementView = ({
  themeJSON,
  colorVariable,
  setIsCashManagement,
  setAddCashFlag,
  setCashAddInFlag,
  cashManagementData,
  cashManagementColumn,
  selectBagRef,
  ...props
}) => {
  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
        fontSize: "1vw",
      }}
    >
      <Row style={{ padding: "1.5em 1.5em 0 1.5em" }}>
        <Col span={6}>
          <img
            src={Back}
            id="sm-cash-management-back"
            onClick={() => {
              setIsCashManagement(false);
            }}
            style={{
              height: "3.1vw",
              paddingBottom: "0.7em",
              cursor: "pointer",
            }}
          />
          <span
            style={{
              paddingRight: "1vw",
              color: "#0F0718",
              fontSize: "1.8em",
              fontWeight: 500,
              marginLeft: "0.5em",
            }}
          >
            Cash Management
          </span>
        </Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Button
            style={{
              width: "10.3vw",
              height: "5.5vh",
              borderRadius: "4px",
              fontWeight: "500",
              marginRight: "1.4vw",
              fontSize: "1em",
              color: "#fff",
              background: "#2F3856",
            }}
            id="sm-cash-management-remove"
            onClick={() => {
              setAddCashFlag(true);
              setCashAddInFlag(true);
            }}
          >
            Remove Cash
          </Button>
          <Button
            id="sm-cash-management-add"
            style={{
              width: "10.3vw",
              height: "5.5vh",
              borderRadius: "4px",
              fontWeight: "500",
              fontSize: "1em",
              color: "#fff",
              background: "#2F3856",
            }}
            onClick={() => {
              setAddCashFlag(true);
              setCashAddInFlag(false);
            }}
          >
            Add Cash
          </Button>
        </Col>
      </Row>
      <br />
      <Row style={{ padding: "0 1.5em" }}>
        <Table
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            fontSize: "1.5vw",
            borderRadius: "10px",
            padding: "0 1em",
            height: "83vh",
            background: themeJSON.productTableBGColor || "#fff",
          }}
          pagination={false}
          columns={cashManagementColumn}
          className="sm-cashmanagement-table"
          dataSource={cashManagementData}
        />
      </Row>
      <RetailModals {...props} selectBagRef={selectBagRef} />
    </div>
  );
};

export default CashManagementView;
